import React, { createContext, useContext, useState, useEffect } from 'react';
import additionalTranslations from './additionalTranslations';

const LanguageContext = createContext();

export const languages = {
  ar: { name: 'العربية', dir: 'rtl', flag: '🇸🇦' },
  en: { name: 'English', dir: 'ltr', flag: '🇺🇸' },
  zh: { name: '中文', dir: 'ltr', flag: '🇨🇳' }
};

// قاموس الترجمات
export const translations = {
  // ===== القائمة الرئيسية والتنقل =====
  'nav.home': {
    ar: 'الرئيسية',
    en: 'Home',
    zh: '首页'
  },
  'nav.dashboard': {
    ar: 'لوحة التحكم',
    en: 'Dashboard',
    zh: '控制面板'
  },
  'nav.cases': {
    ar: 'القضايا',
    en: 'Cases',
    zh: '案件'
  },
  'nav.clients': {
    ar: 'العملاء',
    en: 'Clients',
    zh: '客户'
  },
  'nav.employees': {
    ar: 'الموظفين',
    en: 'Employees',
    zh: '员工'
  },
  'nav.appointments': {
    ar: 'المواعيد',
    en: 'Appointments',
    zh: '预约'
  },
  'nav.consultations': {
    ar: 'الاستشارات',
    en: 'Consultations',
    zh: '咨询'
  },
  'nav.documents': {
    ar: 'المستندات',
    en: 'Documents',
    zh: '文件'
  },
  'nav.invoices': {
    ar: 'الفواتير',
    en: 'Invoices',
    zh: '发票'
  },
  'nav.reports': {
    ar: 'التقارير',
    en: 'Reports',
    zh: '报告'
  },
  'nav.settings': {
    ar: 'الإعدادات',
    en: 'Settings',
    zh: '设置'
  },
  'nav.logout': {
    ar: 'تسجيل الخروج',
    en: 'Logout',
    zh: '退出登录'
  },
  'nav.login': {
    ar: 'تسجيل الدخول',
    en: 'Login',
    zh: '登录'
  },
  'nav.register': {
    ar: 'تسجيل جديد',
    en: 'Register',
    zh: '注册'
  },
  'nav.workSchedule': {
    ar: 'جداول العمل',
    en: 'Work Schedule',
    zh: '工作日程'
  },
  'nav.clientPortal': {
    ar: 'بوابة العميل',
    en: 'Client Portal',
    zh: '客户门户'
  },
  'nav.clientRequests': {
    ar: 'طلبات العملاء',
    en: 'Client Requests',
    zh: '客户请求'
  },
  'nav.virtualCourt': {
    ar: 'المحكمة الافتراضية',
    en: 'Virtual Court',
    zh: '虚拟法庭'
  },
  'nav.legalLibrary': {
    ar: 'المكتبة القانونية',
    en: 'Legal Library',
    zh: '法律图书馆'
  },
  'nav.legalAI': {
    ar: 'المساعد القانوني الذكي',
    en: 'Legal AI Assistant',
    zh: '法律AI助手'
  },
  'nav.attendance': {
    ar: 'الحضور والانصراف',
    en: 'Attendance',
    zh: '考勤'
  },
  'nav.meetings': {
    ar: 'الاجتماعات',
    en: 'Meetings',
    zh: '会议'
  },
  'nav.fees': {
    ar: 'الأتعاب',
    en: 'Fees',
    zh: '费用'
  },
  'nav.vouchers': {
    ar: 'السندات',
    en: 'Vouchers',
    zh: '凭证'
  },
  'nav.financialReports': {
    ar: 'التقارير المالية',
    en: 'Financial Reports',
    zh: '财务报告'
  },

  // ===== الأزرار العامة =====
  'btn.add': {
    ar: 'إضافة',
    en: 'Add',
    zh: '添加'
  },
  'btn.addNew': {
    ar: 'إضافة جديد',
    en: 'Add New',
    zh: '新增'
  },
  'btn.edit': {
    ar: 'تعديل',
    en: 'Edit',
    zh: '编辑'
  },
  'btn.delete': {
    ar: 'حذف',
    en: 'Delete',
    zh: '删除'
  },
  'btn.save': {
    ar: 'حفظ',
    en: 'Save',
    zh: '保存'
  },
  'btn.cancel': {
    ar: 'إلغاء',
    en: 'Cancel',
    zh: '取消'
  },
  'btn.confirm': {
    ar: 'تأكيد',
    en: 'Confirm',
    zh: '确认'
  },
  'btn.submit': {
    ar: 'إرسال',
    en: 'Submit',
    zh: '提交'
  },
  'btn.search': {
    ar: 'بحث',
    en: 'Search',
    zh: '搜索'
  },
  'btn.filter': {
    ar: 'تصفية',
    en: 'Filter',
    zh: '筛选'
  },
  'btn.advancedFilter': {
    ar: 'تصفية متقدمة',
    en: 'Advanced Filter',
    zh: '高级筛选'
  },
  'btn.clearFilters': {
    ar: 'مسح الفلاتر',
    en: 'Clear Filters',
    zh: '清除筛选'
  },
  'btn.refresh': {
    ar: 'تحديث',
    en: 'Refresh',
    zh: '刷新'
  },
  'btn.back': {
    ar: 'رجوع',
    en: 'Back',
    zh: '返回'
  },
  'btn.next': {
    ar: 'التالي',
    en: 'Next',
    zh: '下一步'
  },
  'btn.previous': {
    ar: 'السابق',
    en: 'Previous',
    zh: '上一步'
  },
  'btn.view': {
    ar: 'عرض',
    en: 'View',
    zh: '查看'
  },
  'btn.download': {
    ar: 'تحميل',
    en: 'Download',
    zh: '下载'
  },
  'btn.upload': {
    ar: 'رفع',
    en: 'Upload',
    zh: '上传'
  },
  'btn.print': {
    ar: 'طباعة',
    en: 'Print',
    zh: '打印'
  },
  'btn.export': {
    ar: 'تصدير',
    en: 'Export',
    zh: '导出'
  },
  'btn.close': {
    ar: 'إغلاق',
    en: 'Close',
    zh: '关闭'
  },

  // ===== صفحة تسجيل الدخول =====
  'login.title': {
    ar: 'تسجيل الدخول',
    en: 'Login',
    zh: '登录'
  },
  'login.email': {
    ar: 'البريد الإلكتروني',
    en: 'Email',
    zh: '电子邮件'
  },
  'login.password': {
    ar: 'كلمة المرور',
    en: 'Password',
    zh: '密码'
  },
  'login.rememberMe': {
    ar: 'تذكرني',
    en: 'Remember me',
    zh: '记住我'
  },
  'login.forgotPassword': {
    ar: 'نسيت كلمة المرور؟',
    en: 'Forgot password?',
    zh: '忘记密码？'
  },
  'login.noAccount': {
    ar: 'ليس لديك حساب؟',
    en: "Don't have an account?",
    zh: '没有账户？'
  },
  'login.createAccount': {
    ar: 'إنشاء حساب جديد',
    en: 'Create new account',
    zh: '创建新账户'
  },
  'login.loginBtn': {
    ar: 'دخول',
    en: 'Sign In',
    zh: '登录'
  },

  // ===== صفحة التسجيل =====
  'register.title': {
    ar: 'تسجيل حساب جديد',
    en: 'Create New Account',
    zh: '创建新账户'
  },
  'register.accountType': {
    ar: 'نوع الحساب',
    en: 'Account Type',
    zh: '账户类型'
  },
  'register.selectAccountType': {
    ar: 'اختر نوع الحساب للمتابعة',
    en: 'Select account type to continue',
    zh: '选择账户类型以继续'
  },
  'register.individual': {
    ar: 'حساب أفراد',
    en: 'Individual Account',
    zh: '个人账户'
  },
  'register.individualDesc': {
    ar: 'للأشخاص والأفراد',
    en: 'For individuals and persons',
    zh: '适用于个人'
  },
  'register.company': {
    ar: 'حساب منشآت',
    en: 'Company Account',
    zh: '公司账户'
  },
  'register.companyDesc': {
    ar: 'للشركات والمؤسسات',
    en: 'For companies and institutions',
    zh: '适用于公司和机构'
  },
  'register.changeAccountType': {
    ar: 'تغيير نوع الحساب',
    en: 'Change Account Type',
    zh: '更改账户类型'
  },
  'register.fullName': {
    ar: 'الاسم الكامل',
    en: 'Full Name',
    zh: '全名'
  },
  'register.companyName': {
    ar: 'اسم الشركة',
    en: 'Company Name',
    zh: '公司名称'
  },
  'register.email': {
    ar: 'البريد الإلكتروني',
    en: 'Email',
    zh: '电子邮件'
  },
  'register.phone': {
    ar: 'رقم الجوال',
    en: 'Phone Number',
    zh: '手机号码'
  },
  'register.nationalId': {
    ar: 'رقم الهوية الوطنية',
    en: 'National ID',
    zh: '身份证号'
  },
  'register.commercialRegister': {
    ar: 'السجل التجاري',
    en: 'Commercial Register',
    zh: '商业登记号'
  },
  'register.password': {
    ar: 'كلمة المرور',
    en: 'Password',
    zh: '密码'
  },
  'register.confirmPassword': {
    ar: 'تأكيد كلمة المرور',
    en: 'Confirm Password',
    zh: '确认密码'
  },
  'register.haveAccount': {
    ar: 'لديك حساب بالفعل؟',
    en: 'Already have an account?',
    zh: '已有账户？'
  },
  'register.registerBtn': {
    ar: 'تسجيل',
    en: 'Register',
    zh: '注册'
  },

  // ===== جداول العمل =====
  'workSchedule.title': {
    ar: 'جداول العمل',
    en: 'Work Schedules',
    zh: '工作日程'
  },
  'workSchedule.cases': {
    ar: 'القضايا',
    en: 'Cases',
    zh: '案件'
  },
  'workSchedule.execution': {
    ar: 'طلبات التنفيذ',
    en: 'Execution Requests',
    zh: '执行请求'
  },
  'workSchedule.reviews': {
    ar: 'المراجعات',
    en: 'Reviews',
    zh: '审查'
  },
  'workSchedule.appeals': {
    ar: 'الاستئناف والعليا',
    en: 'Appeals & Supreme',
    zh: '上诉和最高法院'
  },
  'workSchedule.addEntry': {
    ar: 'إضافة إدخال جديد',
    en: 'Add New Entry',
    zh: '添加新条目'
  },
  'workSchedule.editEntry': {
    ar: 'تعديل الإدخال',
    en: 'Edit Entry',
    zh: '编辑条目'
  },
  'workSchedule.caseNumber': {
    ar: 'رقم القضية',
    en: 'Case Number',
    zh: '案件编号'
  },
  'workSchedule.caseType': {
    ar: 'نوع القضية',
    en: 'Case Type',
    zh: '案件类型'
  },
  'workSchedule.court': {
    ar: 'الجهة',
    en: 'Court',
    zh: '法院'
  },
  'workSchedule.parties': {
    ar: 'أطراف القضية',
    en: 'Case Parties',
    zh: '案件当事人'
  },
  'workSchedule.plaintiff': {
    ar: 'المدعي',
    en: 'Plaintiff',
    zh: '原告'
  },
  'workSchedule.defendant': {
    ar: 'المدعى عليه',
    en: 'Defendant',
    zh: '被告'
  },
  'workSchedule.ourClient': {
    ar: 'موكلنا',
    en: 'Our Client',
    zh: '我方当事人'
  },
  'workSchedule.opponent': {
    ar: 'الخصم',
    en: 'Opponent',
    zh: '对方当事人'
  },
  'workSchedule.work': {
    ar: 'العمل',
    en: 'Work',
    zh: '工作'
  },
  'workSchedule.task': {
    ar: 'المهمة',
    en: 'Task',
    zh: '任务'
  },
  'workSchedule.taskDescription': {
    ar: 'المهمة المطلوبة',
    en: 'Required Task',
    zh: '所需任务'
  },
  'workSchedule.dateHijri': {
    ar: 'التاريخ الهجري',
    en: 'Hijri Date',
    zh: '伊斯兰历日期'
  },
  'workSchedule.dateGregorian': {
    ar: 'التاريخ الميلادي',
    en: 'Gregorian Date',
    zh: '公历日期'
  },
  'workSchedule.responsible': {
    ar: 'المسؤولين',
    en: 'Responsible',
    zh: '负责人'
  },
  'workSchedule.consultant': {
    ar: 'مستشار المهمة',
    en: 'Task Consultant',
    zh: '任务顾问'
  },
  'workSchedule.notes': {
    ar: 'ملاحظات',
    en: 'Notes',
    zh: '备注'
  },
  'workSchedule.status': {
    ar: 'الحالة',
    en: 'Status',
    zh: '状态'
  },
  'workSchedule.actions': {
    ar: 'إجراءات',
    en: 'Actions',
    zh: '操作'
  },
  'workSchedule.pending': {
    ar: 'قيد الانتظار',
    en: 'Pending',
    zh: '待处理'
  },
  'workSchedule.inProgress': {
    ar: 'قيد التنفيذ',
    en: 'In Progress',
    zh: '进行中'
  },
  'workSchedule.completed': {
    ar: 'مكتمل',
    en: 'Completed',
    zh: '已完成'
  },
  'workSchedule.backToDashboard': {
    ar: 'العودة للوحة التحكم',
    en: 'Back to Dashboard',
    zh: '返回控制面板'
  },
  'workSchedule.noEntries': {
    ar: 'لا توجد إدخالات في هذا الجدول',
    en: 'No entries in this table',
    zh: '此表中没有条目'
  },
  'workSchedule.resultsCount': {
    ar: 'عدد النتائج',
    en: 'Results count',
    zh: '结果数量'
  },
  'workSchedule.of': {
    ar: 'من أصل',
    en: 'of',
    zh: '共'
  },
  'workSchedule.selectType': {
    ar: 'نوع الجدول',
    en: 'Schedule Type',
    zh: '日程类型'
  },
  'workSchedule.selectCourt': {
    ar: 'اختر الجهة',
    en: 'Select Court',
    zh: '选择法院'
  },
  'workSchedule.selectCaseType': {
    ar: 'اختر نوع القضية',
    en: 'Select Case Type',
    zh: '选择案件类型'
  },
  'workSchedule.selectResponsible': {
    ar: 'اختر المسؤول',
    en: 'Select Responsible',
    zh: '选择负责人'
  },
  'workSchedule.selectConsultant': {
    ar: 'اختر المستشار',
    en: 'Select Consultant',
    zh: '选择顾问'
  },
  'workSchedule.plaintiffRole': {
    ar: 'صفة المدعي',
    en: 'Plaintiff Role',
    zh: '原告身份'
  },
  'workSchedule.defendantRole': {
    ar: 'صفة المدعى عليه',
    en: 'Defendant Role',
    zh: '被告身份'
  },

  // ===== أنواع القضايا =====
  'caseType.criminal': {
    ar: 'جنائية',
    en: 'Criminal',
    zh: '刑事'
  },
  'caseType.civil': {
    ar: 'مدنية',
    en: 'Civil',
    zh: '民事'
  },
  'caseType.commercial': {
    ar: 'تجارية',
    en: 'Commercial',
    zh: '商业'
  },
  'caseType.labor': {
    ar: 'عمالية',
    en: 'Labor',
    zh: '劳动'
  },
  'caseType.personalStatus': {
    ar: 'أحوال شخصية',
    en: 'Personal Status',
    zh: '个人身份'
  },
  'caseType.administrative': {
    ar: 'إدارية',
    en: 'Administrative',
    zh: '行政'
  },
  'caseType.execution': {
    ar: 'تنفيذ',
    en: 'Execution',
    zh: '执行'
  },
  'caseType.appeal': {
    ar: 'استئناف',
    en: 'Appeal',
    zh: '上诉'
  },
  'caseType.supreme': {
    ar: 'عليا',
    en: 'Supreme',
    zh: '最高'
  },
  'caseType.other': {
    ar: 'أخرى',
    en: 'Other',
    zh: '其他'
  },

  // ===== المحاكم =====
  'court.criminal': {
    ar: 'المحكمة الجزائية',
    en: 'Criminal Court',
    zh: '刑事法院'
  },
  'court.general': {
    ar: 'المحكمة العامة',
    en: 'General Court',
    zh: '普通法院'
  },
  'court.commercial': {
    ar: 'المحكمة التجارية',
    en: 'Commercial Court',
    zh: '商业法院'
  },
  'court.labor': {
    ar: 'المحكمة العمالية',
    en: 'Labor Court',
    zh: '劳动法院'
  },
  'court.personalStatus': {
    ar: 'محكمة الأحوال الشخصية',
    en: 'Personal Status Court',
    zh: '个人身份法院'
  },
  'court.administrative': {
    ar: 'المحكمة الإدارية',
    en: 'Administrative Court',
    zh: '行政法院'
  },
  'court.execution': {
    ar: 'محكمة التنفيذ',
    en: 'Execution Court',
    zh: '执行法院'
  },
  'court.appeal': {
    ar: 'محكمة الاستئناف',
    en: 'Court of Appeal',
    zh: '上诉法院'
  },
  'court.supreme': {
    ar: 'المحكمة العليا',
    en: 'Supreme Court',
    zh: '最高法院'
  },

  // ===== الفلاتر =====
  'filter.title': {
    ar: 'فلاتر التصفية',
    en: 'Filters',
    zh: '筛选条件'
  },
  'filter.dateFrom': {
    ar: 'التاريخ من',
    en: 'Date From',
    zh: '开始日期'
  },
  'filter.dateTo': {
    ar: 'التاريخ إلى',
    en: 'Date To',
    zh: '结束日期'
  },
  'filter.all': {
    ar: 'الكل',
    en: 'All',
    zh: '全部'
  },
  'filter.searchPlaceholder': {
    ar: 'بحث في الجدول...',
    en: 'Search in table...',
    zh: '在表格中搜索...'
  },

  // ===== الرسائل =====
  'msg.loading': {
    ar: 'جاري التحميل...',
    en: 'Loading...',
    zh: '加载中...'
  },
  'msg.saving': {
    ar: 'جاري الحفظ...',
    en: 'Saving...',
    zh: '保存中...'
  },
  'msg.success': {
    ar: 'تمت العملية بنجاح',
    en: 'Operation successful',
    zh: '操作成功'
  },
  'msg.error': {
    ar: 'حدث خطأ',
    en: 'An error occurred',
    zh: '发生错误'
  },
  'msg.confirmDelete': {
    ar: 'هل أنت متأكد من الحذف؟',
    en: 'Are you sure you want to delete?',
    zh: '确定要删除吗？'
  },
  'msg.cannotUndo': {
    ar: 'لا يمكن التراجع عن هذا الإجراء',
    en: 'This action cannot be undone',
    zh: '此操作无法撤销'
  },
  'msg.addedSuccess': {
    ar: 'تم إضافة الإدخال بنجاح',
    en: 'Entry added successfully',
    zh: '条目添加成功'
  },
  'msg.updatedSuccess': {
    ar: 'تم تحديث الإدخال بنجاح',
    en: 'Entry updated successfully',
    zh: '条目更新成功'
  },
  'msg.deletedSuccess': {
    ar: 'تم حذف الإدخال بنجاح',
    en: 'Entry deleted successfully',
    zh: '条目删除成功'
  },
  'msg.fillRequired': {
    ar: 'يرجى ملء الحقول المطلوبة',
    en: 'Please fill required fields',
    zh: '请填写必填字段'
  },
  'msg.invalidCredentials': {
    ar: 'بيانات الدخول غير صحيحة',
    en: 'Invalid credentials',
    zh: '凭据无效'
  },
  'msg.loginSuccess': {
    ar: 'تم تسجيل الدخول بنجاح',
    en: 'Login successful',
    zh: '登录成功'
  },
  'msg.logoutSuccess': {
    ar: 'تم تسجيل الخروج بنجاح',
    en: 'Logout successful',
    zh: '退出成功'
  },

  // ===== بوابة العميل =====
  'clientPortal.title': {
    ar: 'بوابة العميل',
    en: 'Client Portal',
    zh: '客户门户'
  },
  'clientPortal.myCases': {
    ar: 'قضاياي',
    en: 'My Cases',
    zh: '我的案件'
  },
  'clientPortal.myRequests': {
    ar: 'طلباتي',
    en: 'My Requests',
    zh: '我的请求'
  },
  'clientPortal.newConsultation': {
    ar: 'طلب استشارة جديدة',
    en: 'New Consultation Request',
    zh: '新咨询请求'
  },
  'clientPortal.notaryService': {
    ar: 'خدمات التوثيق',
    en: 'Notary Services',
    zh: '公证服务'
  },
  'clientPortal.newCase': {
    ar: 'تسجيل قضية جديدة',
    en: 'Register New Case',
    zh: '登记新案件'
  },
  'clientPortal.urgentService': {
    ar: 'خدمة عاجلة',
    en: 'Urgent Service',
    zh: '紧急服务'
  },
  'clientPortal.trackRequest': {
    ar: 'متابعة الطلبات',
    en: 'Track Requests',
    zh: '跟踪请求'
  },

  // ===== لوحة التحكم =====
  'dashboard.welcome': {
    ar: 'مرحباً',
    en: 'Welcome',
    zh: '欢迎'
  },
  'dashboard.totalCases': {
    ar: 'إجمالي القضايا',
    en: 'Total Cases',
    zh: '案件总数'
  },
  'dashboard.activeCases': {
    ar: 'القضايا النشطة',
    en: 'Active Cases',
    zh: '活跃案件'
  },
  'dashboard.pendingTasks': {
    ar: 'المهام المعلقة',
    en: 'Pending Tasks',
    zh: '待处理任务'
  },
  'dashboard.todayAppointments': {
    ar: 'مواعيد اليوم',
    en: "Today's Appointments",
    zh: '今日预约'
  },
  'dashboard.recentActivities': {
    ar: 'النشاطات الأخيرة',
    en: 'Recent Activities',
    zh: '最近活动'
  },
  'dashboard.quickActions': {
    ar: 'إجراءات سريعة',
    en: 'Quick Actions',
    zh: '快捷操作'
  },

  // ===== عام =====
  'common.required': {
    ar: 'مطلوب',
    en: 'Required',
    zh: '必填'
  },
  'common.optional': {
    ar: 'اختياري',
    en: 'Optional',
    zh: '选填'
  },
  'common.yes': {
    ar: 'نعم',
    en: 'Yes',
    zh: '是'
  },
  'common.no': {
    ar: 'لا',
    en: 'No',
    zh: '否'
  },
  'common.or': {
    ar: 'أو',
    en: 'or',
    zh: '或'
  },
  'common.and': {
    ar: 'و',
    en: 'and',
    zh: '和'
  },
  'common.from': {
    ar: 'من',
    en: 'from',
    zh: '从'
  },
  'common.to': {
    ar: 'إلى',
    en: 'to',
    zh: '到'
  },
  'common.date': {
    ar: 'التاريخ',
    en: 'Date',
    zh: '日期'
  },
  'common.time': {
    ar: 'الوقت',
    en: 'Time',
    zh: '时间'
  },
  'common.today': {
    ar: 'اليوم',
    en: 'Today',
    zh: '今天'
  },
  'common.selectLanguage': {
    ar: 'اختر اللغة',
    en: 'Select Language',
    zh: '选择语言'
  },

  // ===== الصفحة الرئيسية =====
  'landing.heroTitle': {
    ar: 'مجموعة المحامي هشام بن يوسف الخياط',
    en: 'Lawyer Hesham Bin Youssef Al-Khayat Group',
    zh: '律师赫沙姆·本·优素福·海亚特集团'
  },
  'landing.heroSubtitle': {
    ar: 'للمحاماة والإستشارات القانونية وخدمة الموثق',
    en: 'For Law, Legal Consulting & Notary Services',
    zh: '法律、法律咨询和公证服务'
  },
  'landing.services': {
    ar: 'خدماتنا',
    en: 'Our Services',
    zh: '我们的服务'
  },
  'landing.aboutUs': {
    ar: 'من نحن',
    en: 'About Us',
    zh: '关于我们'
  },
  'landing.contactUs': {
    ar: 'تواصل معنا',
    en: 'Contact Us',
    zh: '联系我们'
  },
  'landing.getStarted': {
    ar: 'ابدأ الآن',
    en: 'Get Started',
    zh: '立即开始'
  },
  'landing.expertLawyers': {
    ar: 'خبرة قانونية متميزة في خدمتكم',
    en: 'Distinguished Legal Expertise at Your Service',
    zh: '卓越的法律专业知识为您服务'
  },
  'landing.yearsExperience': {
    ar: 'سنوات من الخبرة في مجال المحاماة والاستشارات القانونية',
    en: 'Years of experience in law and legal consulting',
    zh: '多年法律和法律咨询经验'
  },
  'landing.requestConsultation': {
    ar: 'طلب استشارة',
    en: 'Request Consultation',
    zh: '咨询请求'
  },
  'landing.notaryServices': {
    ar: 'خدمات التوثيق',
    en: 'Notary Services',
    zh: '公证服务'
  },
  'landing.urgentService': {
    ar: 'خدمة عاجلة',
    en: 'Urgent Service',
    zh: '紧急服务'
  },
  'landing.urgentConsultation': {
    ar: 'استشارة عاجلة',
    en: 'Urgent Consultation',
    zh: '紧急咨询'
  },
  'landing.urgentNotary': {
    ar: 'توثيق عاجل',
    en: 'Urgent Notary',
    zh: '紧急公证'
  },
  'landing.ourServicesTitle': {
    ar: 'خدماتنا القانونية',
    en: 'Our Legal Services',
    zh: '我们的法律服务'
  },
  'landing.comprehensiveServices': {
    ar: 'نقدم مجموعة شاملة من الخدمات القانونية لتلبية احتياجاتكم',
    en: 'We provide a comprehensive range of legal services to meet your needs',
    zh: '我们提供全面的法律服务以满足您的需求'
  },
  'landing.civilCases': {
    ar: 'القضايا المدنية',
    en: 'Civil Cases',
    zh: '民事案件'
  },
  'landing.civilCasesDesc': {
    ar: 'تمثيل قانوني متميز في جميع القضايا المدنية',
    en: 'Distinguished legal representation in all civil cases',
    zh: '在所有民事案件中提供卓越的法律代理'
  },
  'landing.commercialCases': {
    ar: 'القضايا التجارية',
    en: 'Commercial Cases',
    zh: '商业案件'
  },
  'landing.commercialCasesDesc': {
    ar: 'حلول قانونية للشركات والمؤسسات التجارية',
    en: 'Legal solutions for companies and commercial institutions',
    zh: '为公司和商业机构提供法律解决方案'
  },
  'landing.laborCases': {
    ar: 'القضايا العمالية',
    en: 'Labor Cases',
    zh: '劳动案件'
  },
  'landing.laborCasesDesc': {
    ar: 'حماية حقوق العمال وأصحاب العمل',
    en: 'Protecting the rights of workers and employers',
    zh: '保护工人和雇主的权利'
  },
  'landing.realEstate': {
    ar: 'العقارات والتوثيق',
    en: 'Real Estate & Notary',
    zh: '房地产和公证'
  },
  'landing.realEstateDesc': {
    ar: 'خدمات عقارية وتوثيق شاملة',
    en: 'Comprehensive real estate and notary services',
    zh: '全面的房地产和公证服务'
  },
  'landing.familyLaw': {
    ar: 'الأحوال الشخصية',
    en: 'Family Law',
    zh: '家庭法'
  },
  'landing.familyLawDesc': {
    ar: 'قضايا الطلاق والحضانة والميراث',
    en: 'Divorce, custody, and inheritance cases',
    zh: '离婚、监护权和继承案件'
  },
  'landing.legalConsulting': {
    ar: 'الاستشارات القانونية',
    en: 'Legal Consulting',
    zh: '法律咨询'
  },
  'landing.legalConsultingDesc': {
    ar: 'استشارات قانونية متخصصة لجميع القطاعات',
    en: 'Specialized legal consulting for all sectors',
    zh: '为所有行业提供专业法律咨询'
  },
  'landing.whyChooseUs': {
    ar: 'لماذا تختارنا؟',
    en: 'Why Choose Us?',
    zh: '为什么选择我们？'
  },
  'landing.experience': {
    ar: 'خبرة واسعة',
    en: 'Extensive Experience',
    zh: '丰富的经验'
  },
  'landing.experienceDesc': {
    ar: 'أكثر من 15 عاماً في مجال المحاماة',
    en: 'More than 15 years in the legal field',
    zh: '超过15年的法律领域经验'
  },
  'landing.professionalTeam': {
    ar: 'فريق متخصص',
    en: 'Professional Team',
    zh: '专业团队'
  },
  'landing.professionalTeamDesc': {
    ar: 'نخبة من المحامين والمستشارين المتخصصين',
    en: 'Elite lawyers and specialized consultants',
    zh: '精英律师和专业顾问'
  },
  'landing.clientFirst': {
    ar: 'العميل أولاً',
    en: 'Client First',
    zh: '客户至上'
  },
  'landing.clientFirstDesc': {
    ar: 'نضع مصلحة العميل في مقدمة أولوياتنا',
    en: "We put our client's interest as our top priority",
    zh: '我们将客户利益放在首位'
  },
  'landing.virtualCourtDesc': {
    ar: 'منصة تدريبية لمحاكاة المحاكم',
    en: 'Training platform for court simulation',
    zh: '法庭模拟培训平台'
  },
  'landing.virtualCourtFullDesc': {
    ar: 'أول منصة عربية متكاملة لمحاكاة المحاكم السعودية. تدرّب على المرافعات، تحدَّ نفسك في الألعاب القانونية، واحصل على شهادات معتمدة.',
    en: 'The first comprehensive Arabic platform for simulating Saudi courts. Train on pleadings, challenge yourself in legal games, and get certified certificates.',
    zh: '首个全面的阿拉伯语沙特法院模拟平台。进行辩护培训，在法律游戏中挑战自己，并获得认证证书。'
  },
  'landing.newAvailable': {
    ar: 'جديد - متاح الآن',
    en: 'New - Available Now',
    zh: '新功能 - 现已推出'
  },
  'landing.realisticSimulation': {
    ar: 'محاكاة واقعية',
    en: 'Realistic Simulation',
    zh: '逼真模拟'
  },
  'landing.judicialRoles': {
    ar: '8 أدوار قضائية',
    en: '8 Judicial Roles',
    zh: '8个司法角色'
  },
  'landing.realCases': {
    ar: 'قضايا حقيقية',
    en: 'Real Cases',
    zh: '真实案例'
  },
  'landing.enterNow': {
    ar: 'ادخل الآن',
    en: 'Enter Now',
    zh: '立即进入'
  },
  'landing.footer': {
    ar: 'جميع الحقوق محفوظة',
    en: 'All Rights Reserved',
    zh: '版权所有'
  },
  'landing.address': {
    ar: 'العنوان',
    en: 'Address',
    zh: '地址'
  },
  'landing.phone': {
    ar: 'الهاتف',
    en: 'Phone',
    zh: '电话'
  },
  'landing.email': {
    ar: 'البريد الإلكتروني',
    en: 'Email',
    zh: '电子邮件'
  },
};

// دمج الترجمات الأساسية مع الإضافية
const allTranslations = { ...translations, ...additionalTranslations };

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'ar';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.dir = languages[language].dir;
    document.documentElement.lang = language;
  }, [language]);

  const t = (key, fallback = '') => {
    const translation = allTranslations[key];
    if (!translation) return fallback || key;
    return translation[language] || translation['ar'] || fallback || key;
  };

  const changeLanguage = (lang) => {
    if (languages[lang]) {
      setLanguage(lang);
    }
  };

  const isRTL = languages[language].dir === 'rtl';

  const value = {
    language,
    setLanguage: changeLanguage,
    t,
    isRTL,
    languages,
    dir: languages[language].dir
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
